import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    NavigationEnd,
    NavigationStart,
    Router,
    RouteReuseStrategy,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomRouteReuseStrategy } from './_services/route-reuse.strategy';

@Component({
    selector: 'lokos-root',
    standalone: false,
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'lokos-web-portal';
    private navSub?: Subscription;

    constructor(
        private router: Router,
        private routeReuseStrategy: RouteReuseStrategy,
    ) {}

    ngOnInit(): void {
        const strategy = this.routeReuseStrategy as CustomRouteReuseStrategy;
        this.navSub = this.router.events.subscribe((e) => {
            if (e instanceof NavigationStart) {
                strategy.onNavigationStart(e.url, this.router.url);
                return;
            }
            if (e instanceof NavigationEnd) {
                console.log('[RR] NavigationEnd  :', e.urlAfterRedirects);
                document.body.classList.toggle(
                    'reports-scope',
                    /^\/main\/reports(\/|$|\?|#)/.test(e.urlAfterRedirects),
                );
                const snap = strategy.consumePendingScrollRestore();
                if (!snap) return;
                const apply = (tag: string) => {
                    const sidenav = document.querySelector(
                        'mat-sidenav-content',
                    ) as HTMLElement | null;
                    if (sidenav && snap.matSidenav)
                        sidenav.scrollTop = snap.matSidenav;
                    const outlet = document.getElementById('outlet');
                    if (outlet && snap.outlet) outlet.scrollTop = snap.outlet;
                    if (snap.window) window.scrollTo(0, snap.window);
                    console.log('[RR] scrollApply', tag, '→', {
                        sidenavSet: sidenav ? sidenav.scrollTop : null,
                        outletSet: outlet ? outlet.scrollTop : null,
                        windowSet: window.scrollY,
                        snap,
                    });
                };
                requestAnimationFrame(() =>
                    requestAnimationFrame(() => {
                        apply('raf2');
                        setTimeout(() => apply('t50'), 50);
                    }),
                );
            }
        });
    }

    ngOnDestroy(): void {
        this.navSub?.unsubscribe();
    }
}
